import React from "react";

import { GOOGLE_PLAYSTORE, APPLE_PLAYSTORE } from "../../utils/constant";

import "./mobile-play-store.m.css";
import Icon from "../../icons/app-store";

const MobilePlayStore = () => (
  <div styleName="wrapper">
    <span styleName="description">মোবাইল অ্যাপস ডাউনলোড করুন</span>

    <div styleName="app-store">
      <a href={APPLE_PLAYSTORE} styleName="app-store-link" target="_blank" rel="noopener noreferrer">
        <Icon type="apple-store" className="apple-store" />
      </a>
      <a href={GOOGLE_PLAYSTORE} target="_blank" rel="noopener noreferrer">
        <Icon type="google-play" className="google-play" />
      </a>
    </div>
  </div>
);

export default MobilePlayStore;
